import React from 'react';
interface SectionHeaderProps {
  id: string;
  eyebrow?: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  eyebrowTone?: 'accent' | 'success' | 'danger';
}
export function SectionHeader({
  id,
  eyebrow,
  title,
  description,
  eyebrowTone = 'accent'
}: SectionHeaderProps) {
  const tones = {
    accent: 'text-accent',
    success: 'text-success',
    danger: 'text-danger'
  };
  return <div className="text-center" data-id="element-161" data-mp="2v7j0zdjeart4">
      {eyebrow && <p className={`font-display text-xs font-bold uppercase tracking-wide sm:text-sm ${tones[eyebrowTone]}`} data-id="element-162" data-mp="305kk1ygtmr4l">
          {eyebrow}
        </p>}
      <h2 id={id} className="mt-1.5 font-display text-xl font-extrabold leading-tight text-ink sm:text-3xl" data-id="element-163" data-mp="2l7ig3n5vo3mt">
        {title}
      </h2>
      {description && <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-muted sm:text-base" data-id="element-164" data-mp="19s3iqi9rb9r6">
          {description}
        </p>}
    </div>;
}